import React from "react";
import Layout from "../../Components/Layout";
import { Link } from "react-router-dom";

const faqs = [
  ["Que récupère WBC ?", "Des trop-payés, écarts de prix, escomptes non appliqués, ristournes de bon paiement, avoirs non imputés, doubles règlements, erreurs de TVA, indexations de baux et anomalies fournisseurs validables."],
  ["Quels documents faut-il transmettre ?", "FEC, balances fournisseurs, grands livres, factures, avoirs, commandes, réceptions, contrats, conditions tarifaires, conventions, annexes, emails fournisseurs et baux commerciaux selon le périmètre."],
  ["Comment démarre une mission ?", "Par un cadrage du périmètre : entités, fournisseurs, périodes, familles d'achats, qualité des données disponibles, enjeux de trésorerie et niveau de preuve attendu."],
  ["Comment les écarts sont-ils détectés ?", "WBC rapproche les tarifs attendus, commandes, réceptions, factures, avoirs et écritures comptables afin de repérer les différences de prix, quantités, dates, taxes ou conditions commerciales."],
  ["Comment sont calculés les tarifs ?", "Selon la taille de l'entreprise, le nombre d'entités, le volume de factures, le nombre de fournisseurs, les années auditées, la qualité des données et la complexité du recouvrement."],
  ["Quel est le modèle économique ?", "Une proposition peut combiner diagnostic, audit complet et part liée au succès lorsque le potentiel de récupération est mesurable et documenté."],
  ["Quels livrables obtient le client ?", "Synthèse direction, fichiers de calcul, détail par fournisseur, preuve documentaire, plan de recouvrement, priorisation des actions et recommandations pour corriger les causes."],
  ["Combien peut-on récupérer ?", "Le montant dépend du dossier. WBC vise des anomalies prouvables et négociables, avec un objectif commercial de convertir 30 à 40% du potentiel identifié en revenus effectivement récupérés lorsque les preuves sont solides."],
  ["Pour qui est-ce utile ?", "DAF, directions achats, contrôle de gestion, directions générales, retail, distribution, industrie, groupes multi-sites et sociétés à volume fournisseur élevé."],
  ["Les données sensibles sont-elles nécessaires ?", "WBC travaille sur les pièces indispensables au contrôle et peut définir un périmètre progressif : échantillon, fournisseurs prioritaires, période limitée, puis extension si le potentiel est confirmé."],
  ["Que se passe-t-il après l'audit ?", "Les écarts sont qualifiés, documentés, priorisés puis transformés en actions : demandes d'avoir, négociation fournisseur, correction tarifaire, sécurisation du process ou arbitrage interne."],
  ["Pourquoi formaliser la méthode sur le site ?", "Un dirigeant doit comprendre rapidement le périmètre, les preuves attendues, le mode de calcul et les livrables avant de demander une proposition commerciale."],
];

const methodology = [
  ["1. Cadrage", "Définition des entités, fournisseurs, familles d'achats, périodes auditées, objectifs financiers et contraintes de confidentialité."],
  ["2. Collecte documentaire", "Centralisation des FEC, grands livres, factures, avoirs, commandes, réceptions, contrats, conditions tarifaires, baux et annexes."],
  ["3. Normalisation", "Nettoyage des formats, rapprochement des référentiels, préparation des bases de calcul et contrôle de cohérence des données."],
  ["4. Détection", "Recherche des écarts de prix, doublons, escomptes oubliés, ristournes de bon paiement, erreurs de taxes, avoirs manquants et anomalies de baux."],
  ["5. Qualification", "Séparation entre signal faible, erreur probable, écart documenté et montant réellement négociable ou recouvrable."],
  ["6. Dossier de preuve", "Construction d'un dossier exploitable par fournisseur avec fichiers de calcul, pièces justificatives, synthèse direction et recommandations."],
  ["7. Recouvrement", "Priorisation des actions, préparation des demandes, appui à la négociation fournisseur et sécurisation des corrections futures."],
];

const KnowledgeCatalog = () => {
  return (
    <div className="knowledge-wrapper">
      <Layout>
        <section className="knowledge-hero pt-100 pb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9 text-center section-content">
                <span className="fs-15 fw-semibold sub-titles banner-sub text-white">Méthodologie WBC</span>
                <h1 className="fs-60 mt-3 fw-bold text-white">Auditer les accords commerciaux et récupérer les marges perdues</h1>
                <p className="fs-18 text-white">
                  Cette page rassemble la méthode, les documents utiles, les livrables et les questions clés pour cadrer une mission WBC. Elle permet à un dirigeant, un DAF ou une direction achats de comprendre rapidement comment transformer des anomalies fournisseurs en revenus récupérables.
                </p>
                <div className="section-content-btn justify-content-center">
                  <Link to="/services" className="btn-lg primary-btn fs-18 fw-semibold br-10">Voir les missions</Link>
                  <Link to="/contact" className="btn-lg white-border-btn fs-18 fw-semibold br-10">Demander une proposition</Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="knowledge-section pt-100 pb-100">
          <div className="container">
            <div className="row row-gap-40">
              <div className="col-lg-5 section-content">
                <span className="fs-15 fw-semibold sub-titles">Périmètre d'audit</span>
                <h2 className="fs-50 mt-3 fw-bold">Ce que WBC contrôle dans vos flux fournisseurs</h2>
                <p className="fs-18">
                  L'avantage WBC vient d'une expertise très spécifique : conditions tarifaires, FEC, pricing, écarts de prix, escomptes, baux commerciaux et recouvrement fournisseur. Les contrôles sont organisés pour produire une preuve exploitable, pas uniquement une liste d'anomalies.
                </p>
              </div>
              <div className="col-lg-7">
                <div className="proof-grid">
                  <div className="proof-card"><strong>Services</strong><span>Audit fournisseurs, pricing, FEC, baux, escomptes, doublons, avoirs et recouvrement.</span></div>
                  <div className="proof-card"><strong>Cas</strong><span>ITM : mise en place et analyse d'écarts de prix. Carrefour : contrôle fournisseur et pricing.</span></div>
                  <div className="proof-card"><strong>Tarifs</strong><span>Méthode variable selon taille, volume, complexité, qualité des données et potentiel recouvrable.</span></div>
                  <div className="proof-card"><strong>Résultats</strong><span>Objectif : convertir 30 à 40% des revenus identifiés en récupération validée selon dossier.</span></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="publication-area pt-100 pb-100">
          <div className="container">
            <div className="row row-gap-40 align-items-start">
              <div className="col-lg-5 section-content">
                <span className="fs-15 fw-semibold sub-titles">Méthode d'audit</span>
                <h2 className="fs-50 mt-3 fw-bold">Une démarche claire du cadrage au recouvrement</h2>
                <p className="fs-18">
                  La mission est construite étape par étape afin de sécuriser la preuve, prioriser les montants et donner au client une base solide pour décider, négocier et récupérer.
                </p>
              </div>
              <div className="col-lg-7">
                <ul className="channel-list">
                  {methodology.map(([step, text]) => <li key={step}><strong>{step}</strong> - {text}</li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-area pt-100 pb-100">
          <div className="container">
            <div className="section-content text-center pb-60">
              <span className="fs-15 fw-semibold sub-titles">FAQ dirigeants</span>
              <h2 className="fs-50 mt-3 fw-bold">Les questions à clarifier avant une mission</h2>
            </div>
            <div className="faq-grid">
              {faqs.map(([question, answer]) => (
                <article className="faq-card" key={question}>
                  <h3 className="fs-20 fw-bold">{question}</h3>
                  <p className="fs-18">{answer}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </Layout>
    </div>
  );
};

export default KnowledgeCatalog;